<!-->┌──────────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│                                       Login                                          │<- ->
<- ->└──────────────────────────────────────────────────────────────────────────────────────┘<--->

<template>
    <div class="rewards-login-form">
        <h3 class="rewards-title">{{ TEXT.REWARDS_PROGRAM }} Login</h3>

        <form class="form-fields" @submit.prevent="doLogin">
            <div class="user-input">
                <labeled-text-input name="login" id="memberId" class="member-id" v-model="memberId" @change="resetErrors()" has-icon @update:ref="$refs.memberId=$event">Member ID</labeled-text-input>
                <labeled-text-input name="password" id="memberPwd" class="member-password" type="password" v-model="password" @change="resetErrors()" has-icon @update:ref="$refs.password=$event">Password</labeled-text-input>
            </div>

            <div class="user-options">
                <label :class="{'remember-me':1, selected: rememberMe}">Remember me<input type="checkbox" v-model="rememberMe" @keyup.enter="rememberMe = !rememberMe" /></label>
                <label :class="{'keep-alive':1, selected: keepAlive}">Keep me logged in<input type="checkbox" v-model="keepAlive" @keyup.enter="keepAlive = !keepAlive" /></label>
            </div>

            <div class="user-action">
                <button class="submit button-s">Sign In</button>
            </div>
        </form>

        <div class="errors">
            <ul v-for="(error, index) in errorDict" :key="index">
                <li>{{ error }}</li>
            </ul>
        </div>

        <transition-expand v-if="error || exception" classList="conflicts-container">
            <conflicts :error.sync="error" :exception.sync="exception" :is-sys-admin="isSysAdmin"></conflicts>
        </transition-expand>
    </div>
</template>

<script>
    import { queryJSON } from "@/helpers/fetch"
    import conflicts, { CONFLICTS } from "@/common/conflicts"

    export default {
        components: { conflicts },
        mixins: [CONFLICTS],

        emits: ['submitting', 'submitted'],

        name: 'Login',
        data() {
            return {
                token: null,
                memberId: null,
                password: null,

                errorDict: {},

                keepAlive: false,
                rememberMe: false,

                submitting: false,
            }
        },

        methods: {
            resetErrors() {
                this.exception = null
                this.error = this.exception = null
            },

            doLogin($event) {
                if ($event && $event.ctrlKey)
                    var timeout = prompt("Enter desired session duration in minutes:")

                //Validation
                this.errorDict = {};

                if (this.memberId) {
                    let memberId = parseInt(this.memberId);

                    //Check to see if memberId contains any characters
                    let regexLetterCheck = /[A-Za-z]/.test(memberId);

                    if (memberId < 0) this.errorDict["NegativeNumber"] = "MemberId cannot be a negative number.";
                    if (isNaN(memberId) || regexLetterCheck) this.errorDict["NotANumber"] = "MemberId must only contain numbers.";

                    //If there are no errors in the errorDict, proceed with fetchJSON function to Login
                    if (Object.keys(this.errorDict).length === 0) {

                        this.savedId = this.rememberMe ? this.memberId : null
                        if (this.submitting) {
                            alert('Login in process; please wait ...')
                        }
                        else {
                            this.$emit('submitting')
                            this.submitting = true

                            queryJSON('/api/members/DoLogin', {
                                id: memberId,
                                pwd: this.password,
                                // 'true'/'false' is ok to the service, but 'on'/'' is not (that's how queryJSON does it)
                                keepAlive: `${this.keepAlive}`,
                                timeout
                            })
                                .then(() => {
                                    this.$emit('close');
                                })
                                .catch(this.onThrow)
                                .finally(() => {
                                    this.$emit('submitted')
                                    this.submitting = false
                                })
                        }
                    }
                } else {
                    if (this.memberId.length < 1) this.errorDict["InputBlank"] = "MemberId cannot be left blank.";
                }
            }
        },

        computed: {
            savedId: {
                get() {
                    return localStorage.getItem("FFM_ID")
                },
                set(id) {
                    if (id)
                        localStorage.setItem("FFM_ID", id)
                    else
                        localStorage.removeItem("FFM_ID")
                }
            }
        },

        mounted() {
            if (this.$refs.password && this.$refs.memberId) {
                if (this.savedId) {
                    this.memberId = this.savedId
                    this.rememberMe = true
                    this.$refs.password.focus()
                }
                else
                    this.$refs.memberId.focus()
            }
        }
    }
</script>

<style>
    .errors li {
        color: red;
    }
</style>